import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MealPlanClass} from '../../class/meal-plan/meal-plan.class';
import {OptionsMealPlanEnum} from '../../enums/meal-plan';
import {MealPlanAppointmentResponseDTO} from '../../dtos/meal-plan';
import {IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';

@Component({
  selector: 'app-options-meal-plan',
  templateUrl: './options-meal-plan.component.html',
  styleUrls: ['./options-meal-plan.component.scss']
})
export class OptionsMealPlanComponent implements OnInit {

  optionsMealPlanEnum = OptionsMealPlanEnum;
  @Input() temporalMealPlan: MealPlanClass;
  @Input() mealPlanAppointment: MealPlanAppointmentResponseDTO;
  @Input() shadow = true;
  @Input() showOptionsActivePlan = true;
  @Input() showDownloadOption = true;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() showOptions = true;
  @Output() optionSelected: EventEmitter<OptionsMealPlanEnum> = new EventEmitter<OptionsMealPlanEnum>();
  @Output() assign: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() download: EventEmitter<boolean> = new EventEmitter<boolean>();
  userLogged: IUser;
  constructor(
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.userLogged = this.storageService.getLocalItem<{ user: IUser, token: string }>('user')?.user;
  }

  onEmitSelectOptionMealPlan(option: OptionsMealPlanEnum): void {
    this.optionSelected.emit(option);
  }

  onDownloadTemplate(): void {
    this.download.emit(true);
  }

  onEmitAssignToAppointment(): void {
    this.assign.emit(true);
  }
}
